<ion-header>
  <div class="flex-space-between" style="padding: 8px">
    <div class="button-container flexed-align-center">
      <div class="flexed-align-center">
        <ion-searchbar
          mode="ios"
          placeholder="Search members..."
          showCancelButton="never"
          class="rounded-search-bar"
          (ionInput)="handleSearch($event)"
        ></ion-searchbar>
      </div>
    </div>
    <div style="display: flex">
      <ion-button (click)="openAddMemberModal()" [disabled]="!canEditMembers">
        <ion-icon name="person-add-outline"></ion-icon>
        <span class="text-with-left-icon hidden-sm"> Add Member </span>
      </ion-button>
    </div>
  </div>
</ion-header>
<ion-content>
  <div class="constrained-content">
    <ion-card class="outline-card">
      <ngx-datatable
        class="material datatable-row-borders"
        [columnMode]="ColumnMode.force"
        [limit]="limit"
        [headerHeight]="44"
        [footerHeight]="50"
        [rowHeight]="50"
        [scrollbarH]="true"
        style="height: unset"
        paginated
        [dataSource]="projectMembersDataSource"
        [loadingIndicator]="isLoading"
      >
        <ngx-datatable-column name="Name" [minWidth]="225">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <div style="display: flex; align-items: center; font-weight: 500">
              <ng-container *ngIf="row.entity.type === ENTITY_TYPES.USER">
                <ion-avatar
                  class="user-photo clickable"
                  [routerLink]="['/dashboard/people', row.entityId]"
                >
                  <app-avatar
                    size="40"
                    [name]="row.entity?.name"
                    [image]="row.entity.photo"
                  ></app-avatar>
                </ion-avatar>
                <a
                  [routerLink]="['/dashboard/people', row.entityId]"
                  class="text-link"
                  *ngIf="row.entity.name"
                >
                  {{ row.entity?.name }}
                </a>
              </ng-container>
              <ng-container *ngIf="row.entity.type === ENTITY_TYPES.USER_GROUP">
                <ion-avatar class="user-photo">
                  <app-avatar
                    size="40"
                    [name]="row.entity?.name"
                    [image]="row.entity.photo"
                  ></app-avatar>
                </ion-avatar>
                {{ row.entity?.name }}
              </ng-container>
            </div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Email" [minWidth]="225">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.entity.email }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Role" [minWidth]="225" [sortable]="false">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <div
              *ngIf="row.role === PROJECT_MEMBER_ROLES.OWNER"
              ngxTippy
              data-tippy-content="Can configure all aspects of the project"
              [tippyProps]="{
                placement: 'bottom'
              }"
            >
              <ion-icon
                name="{{ PROJECT_MEMBER_ROLE_ICONS[row.role] }}"
              ></ion-icon>
              {{ PROJECT_MEMBER_ROLE_NAMES[row.role] }}
              <a (click)="changeRole(row)" *ngIf="canEditMembers">
                <ion-icon name="chevron-down-outline"></ion-icon>
              </a>
            </div>

            <div
              *ngIf="row.role === PROJECT_MEMBER_ROLES.AGENT"
              ngxTippy
              data-tippy-content="Can respond to conversations in the project"
              [tippyProps]="{
                placement: 'bottom'
              }"
            >
              <ion-icon
                name="{{ PROJECT_MEMBER_ROLE_ICONS[row.role] }}"
              ></ion-icon>
              {{ PROJECT_MEMBER_ROLE_NAMES[row.role] }}
              <a (click)="changeRole(row)" *ngIf="canEditMembers">
                <ion-icon name="chevron-down-outline"></ion-icon>
              </a>
            </div>

            <div
              *ngIf="row.role === PROJECT_MEMBER_ROLES.STANDARD"
              ngxTippy
              data-tippy-content="Access to all conversations and customers in the project"
              [tippyProps]="{
                placement: 'bottom'
              }"
            >
              {{ PROJECT_MEMBER_ROLE_NAMES[row.role] }}
              <a (click)="changeRole(row)" *ngIf="canEditMembers">
                <ion-icon name="chevron-down-outline"></ion-icon>
              </a>
            </div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Type" [minWidth]="100">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.entity.type === ENTITY_TYPES.USER ? "User" : "User Group" }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column
          name=""
          [minWidth]="100"
          [maxWidth]="100"
          [sortable]="false"
        >
          <ng-template let-row="row" ngx-datatable-cell-template>
            <a (click)="removeMember(row.entityId)" *ngIf="canEditMembers">
              Remove
            </a>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </ion-card>
  </div>
</ion-content>

<ion-modal #addMemberModal [cssClass]="'auto-height modal-skinny'">
  <ng-template>
    <ion-header class="modal-header">
      <ion-toolbar>
        <div class="modal-title">
          <h3>Add Member</h3>
        </div>
        <ion-buttons slot="end">
          <ion-button
            fill="clear"
            shape="round"
            class="close-button"
            (click)="addMemberModal.dismiss()"
          >
            <ion-icon name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <div class="inner-content" style="padding: 15px">
      <ion-label class="input-label">User or Group</ion-label>
      <ion-chip
        mode="ios"
        [outline]="true"
        class="select-chip select-outline"
        (click)="showMemberOptions()"
        style="width: 100%"
      >
        <ion-label class="select-label">
          <div>
            <ion-icon name="person-outline"></ion-icon>
            {{ newMember?.name ?? "Choose..." }}
          </div>
          <ion-icon
            name="chevron-down-outline"
            class="icon-padded-left"
          ></ion-icon>
        </ion-label>
      </ion-chip>
      <ion-label class="input-label margin-top-15">
        Role
        <ion-icon
          name="information-circle"
          ngxTippy
          [tippyProps]="{
            touch: false,
            arrow: false,
            placement: 'bottom',
            allowHTML: true,
            content:
              '<strong>Roles:</strong><ul><li>Standard: can view conversations and customers</li><li>Agent: can be assigned to and respond to conversations</li><li>Owner: can manage settings and admins</li></ul>'
          }"
        >
        </ion-icon>
      </ion-label>
      <ion-chip
        mode="ios"
        [outline]="true"
        class="select-chip select-outline"
        (click)="showRoleOptions()"
        style="width: 100%"
      >
        <ion-label class="select-label">
          <div>
            <ion-icon name="shield-outline"></ion-icon>
            {{
              newMemberRole
                ? PROJECT_MEMBER_ROLE_NAMES[newMemberRole]
                : "Choose role..."
            }}
          </div>
          <ion-icon
            name="chevron-down-outline"
            class="icon-padded-left"
          ></ion-icon>
        </ion-label>
      </ion-chip>

      <!-- Welcome email checkbox - only show for users -->
      <div
        *ngIf="newMember?.type === ENTITY_TYPES.USER"
        class="flexed margin-top-20"
      >
        <ion-checkbox [(ngModel)]="sendWelcomeEmail" class="small-checkbox">
        </ion-checkbox>
        <ion-label class="input-label">Notify via email</ion-label>
      </div>

      <ion-footer class="footer ion-no-border">
        <ion-button
          (click)="submit()"
          size="block"
          class="no-margin"
          [disabled]="isSubmitting || !isValidNewMember()"
        >
          Add to project
          <ion-spinner
            name="crescent"
            [hidden]="!isSubmitting"
            style="margin-left: 10px"
          ></ion-spinner>
        </ion-button>
      </ion-footer>
    </div>
  </ng-template>
</ion-modal>
